import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import PhoneInput from 'react-phone-input-2';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import 'react-phone-input-2/lib/style.css';
import { BASE_URL } from '../config/constants';
const Signup = () => {
	const [confirmPassword, setConfirmPassword] = useState('');
	const [message, setMessage] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [passwordCheck, setPasswordCheck] = useState(true);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const [signup, setSignup] = useState({
		firstName: '',
		lastName: '',
		email: '',
		password: '',
		phone: '',
		country: '',
	});

	const [errors, setErrors] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		country: '',
		password: '',
	});

	const handlePasswordChange = (e) => {
		const { value } = e.target;
		setSignup({ ...signup, password: value });

		const passwordError = validateField('password', value);
		setErrors({ ...errors, password: passwordError });
	};

	const validateField = (name, value) => {
		const lowerCase = /[a-z]/;
		const upperCase = /[A-Z]/;
		const numbers = /[0-9]/;
		const specialCharacters = /[!@#$%^&*(),.?":{}|<>]/;

		switch (name) {
			case 'firstName':
			case 'lastName':
				if (!/^[a-zA-Z\s]+$/.test(value)) {
					return 'Only letters are allowed';
				}
				break;
			case 'email':
				if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
					return 'Invalid email format';
				}
				break;
			case 'phone':
				if (!/^[0-9]{10,15}$/.test(value)) {
					return 'Phone number must be 10-15 digits';
				}
				break;
			case 'password':
				if (!lowerCase.test(value)) {
					return 'Password must contain at least one lowercase letter';
				}
				if (!upperCase.test(value)) {
					return 'Password must contain at least one uppercase letter';
				}
				if (!numbers.test(value)) {
					return 'Password must contain at least one number';
				}
				if (!specialCharacters.test(value)) {
					return 'Password must contain at least one special character';
				}
				break;
			case 'country':
				if (!/^\S.*$/.test(value)) {
					return 'Country cannot be empty';
				}
				break;
			default:
				break;
		}
		return '';
	};

	const handleBlur = (e) => {
		const { name, value } = e.target;
		const error = validateField(name, value);
		setErrors({ ...errors, [name]: error });
	};

	const handleSignup = async (e) => {
		e.preventDefault();

		if (signup.password !== confirmPassword) {
			setPasswordCheck(false);
			return;
		}

		setPasswordCheck(true);
		setIsLoading(true);
		setMessage('');
		const baseUrl = BASE_URL;
		try {
			const response = await fetch(`${baseUrl}/api/v1/auth/email/register`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					...signup,
					country: country ? country.label : '',
				}),
			});

			if (response.ok) {
				setMessage(
					'Signed up successfully! Please check your email for verification.'
				);
			} else {
				const data = await response.json();
				setMessage(data.errors[Object.keys(data.errors)]);
			}
		} catch (error) {
			setMessage('Server error. Please try again later.');
		} finally {
			setIsLoading(false);
		}
	};

	const [country, setCountry] = useState(null);
	const options = countryList().getData();

	const changeHandler = (country) => {
		setCountry(country);
	};

	const handlePhoneChange = (value) => {
		setSignup({ ...signup, phone: `+${value}` });
	};

	return (
		<div className='bg-white'>
			<section className='bg-main h-[40vh] md:h-[50vh] flex justify-center items-center mb-16'>
				<h2 className='text-2xl md:text-5xl text-white font-semibold'>
					Sign Up
				</h2>
			</section>
			<div className='container mb-16 md:w-5/12'>
				<form
					className='bg-[#f2f3f5] flex flex-col gap-4 p-6 md:p-6 items-center rounded'
					onSubmit={handleSignup}>
					{/* First Name */}
					<div className='input-group w-full'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type='text'
							name='firstName'
							required
							placeholder='First Name'
							value={signup.firstName}
							onChange={(e) =>
								setSignup({ ...signup, firstName: e.target.value })
							}
							onBlur={handleBlur}
						/>
						{errors.firstName && (
							<p className='text-red-700 text-sm'>{errors.firstName}</p>
						)}
					</div>
					{/* Last Name */}
					<div className='input-group w-full'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type='text'
							name='lastName'
							required
							placeholder='Last Name'
							value={signup.lastName}
							onChange={(e) =>
								setSignup({ ...signup, lastName: e.target.value })
							}
							onBlur={handleBlur}
						/>
						{errors.lastName && (
							<p className='text-red-700 text-sm'>{errors.lastName}</p>
						)}
					</div>
					{/* Email */}
					<div className='input-group w-full'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type='email'
							name='email'
							required
							placeholder='Email'
							value={signup.email}
							onChange={(e) => setSignup({ ...signup, email: e.target.value })}
							onBlur={handleBlur}
						/>
						{errors.email && (
							<p className='text-red-700 text-sm'>{errors.email}</p>
						)}
					</div>
					{/* Country */}
					<div className='input-group w-full'>
						<Select
							options={options}
							value={country}
							onChange={changeHandler}
						/>
						{errors.country && (
							<p className='text-red-700 text-sm'>{errors.country}</p>
						)}
					</div>
					{/* Phone */}
					<div className='input-group w-full '>
						<PhoneInput
							country={country ? country.value.toLowerCase() : 'us'}
							value={signup.phone}
							onChange={handlePhoneChange}
							enableSearch={true}
							inputStyle={{ width: '100%' }}
						/>
						{errors.phone && (
							<p className='text-red-700 text-sm'>{errors.phone}</p>
						)}
					</div>
					{/* Passwords */}
					<div className='input-group w-full relative'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type={showPassword ? 'text' : 'password'}
							name='password'
							required
							placeholder='Password'
							value={signup.password}
							onChange={handlePasswordChange}
						/>
						<span
							className='absolute right-3 top-3 cursor-pointer'
							onClick={() => setShowPassword(!showPassword)}>
							{showPassword ? <FaEyeSlash /> : <FaEye />}
						</span>
						{errors.password && (
							<p className='text-red-700 text-sm'>{errors.password}</p>
						)}
					</div>
					<div className='input-group w-full relative'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type={showConfirmPassword ? 'text' : 'password'}
							required
							placeholder='Confirm Password'
							value={confirmPassword}
							onChange={(e) => setConfirmPassword(e.target.value)}
						/>
						<span
							className='absolute right-3 top-3 cursor-pointer'
							onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
							{showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
						</span>
					</div>
					{!passwordCheck && (
						<p className='text-red-700 self-start text-sm'>
							Passwords do not match
						</p>
					)}
					<div className='input-group w-full'>
						<button
							type='submit'
							disabled={isLoading}
							className={`text-center w-full p-3 rounded text-main font-bold ${
								isLoading ? 'bg-gray-400' : 'bg-secondary'
							}`}>
							{isLoading ? 'Creating Account...' : 'Create Account'}
						</button>
					</div>
					{message && (
						<p
							className={`text-sm ${
								message.includes('successfully')
									? 'text-green-600'
									: 'text-red-700'
							}`}>
							{message}
						</p>
					)}
					<div className='self-start text-textColor'>
						<Link
							to='/login'
							className='font-bold md:hover:text-secondary transition-all duration-300 text-xl'>
							Login
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Signup;
